module.exports = __webpack_public_path__ + "static/service-shape3-c369c973231118008bd9b5f03b9dc9f8.png";